<template>
	<div :class="[{ active: !isOpen }, 'faqline']">
		<div class="question" @click="open()">
			<i>Q</i>
			<p>{{ question }}</p>
		</div>
		<transition name="slide-fade">
			<div class="answer" v-if="!isOpen">
				<i>A</i>
				<p v-html="answer"></p>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'faqLine',
	props: {
		question: {
			type: String,
			default: '',
		},
		answer: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			isOpen: true,
		};
	},
	methods: {
		open() {
			this.isOpen = !this.isOpen;
		},
	},
};
</script>

<style scoped lang="scss">
.faqline {
	font-weight: bold;
	border-bottom: 2px solid #00797f;
	padding: 30px 20px;

	&.active {
		.question {
			position: relative;
			&:after {
				content: url('../../assets/img/faq/minus.svg');
			}
		}
	}
}
.question,
.answer {
	display: flex;
	align-items: center;
	// @media print,screen and (max-width: 767px) {
	// justify-content: space-between;
	// }
	i {
		width: 3em;
		@media print, screen and (min-width: 768px) {
			margin-right: 50px;
		}
		@media print, screen and (max-width: 767px) {
			width: 2em;
		}
	}
	p {
		margin: 0;
	}
}
.question {
	position: relative;
	@media (hover: hover) {
		&:hover {
			cursor: pointer;
		}
	}
	p {
		width: calc(100% - 3em - 50px);
		@media print, screen and (max-width: 767px) {
			width: calc(100% - 2em - 30px);
		}
	}
	&:after {
		content: url('../../assets/img/faq/plus.svg');
		width: 26px;
		height: 26px;
		display: inline-block;
		position: relative;
		right: 0;
	}
	i {
		color: #3fae00;
	}
}
.answer {
	margin-top: 1em;
	p {
		width: calc(100% - 3em);
		@media print, screen and (max-width: 767px) {
			width: calc(100% - 2em);
		}
	}
	i {
		color: #00797f;
	}
}
.slide-fade-enter-active {
	transition: all 0.3s ease;
}
.slide-fade-leave-active {
	transition: all 0.2s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(-10px);
	opacity: 0;
}
</style>
